import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import { Col, Form, Row, Select, Input, InputNumber } from 'antd';
import { SearchSelector } from '../Atoms/SearchSelector';
import {
  useFetchFormsSATWithApiKey,
  useFetchMethodsPayWithApiKey,
} from '../../Hooks';
import { generateQueries } from '../../Utils/query';
import { codeMap } from '../../Utils/codeMap';

const formSearch = [
  {
    name: 'description',
    type: 'input',
    whitelist: true,
  },
  {
    name: 'status',
    type: 'select',
  },
];

export const TicketForm = ({
  formRef,
  onSubmit,
  oOrder,
  onValuesChange,
  oClient,
}) => {
  const [disablePaymentForm, setDisablePaymentForm] = useState(false);
  const [formspays, pLoading, fQuery] = useFetchFormsSATWithApiKey();
  const [methods, mLoading] = useFetchMethodsPayWithApiKey('code=PUE');

  useEffect(() => {
    formRef.setFieldsValue({
      total: oOrder?.total_neto,
    });
  }, [oOrder, formRef]);

  useEffect(() => {
    if (
      oOrder?.detelle_ticket &&
      typeof oOrder.detelle_ticket === 'object' &&
      !Array.isArray(oOrder.detelle_ticket) &&
      oOrder.detelle_ticket.codformapago
    ) {
      const cod = oOrder.detelle_ticket.codformapago;
      const mappedCode = codeMap[cod];
      if (mappedCode && formspays?.data?.length) {
        const found = formspays.data.find(fp => fp.code === mappedCode);
        if (found) {
          formRef.setFieldsValue({
            payment_form: `${found.code}&${found.id}`,
          });
          setDisablePaymentForm(true);
          return;
        }
      }
    }
    setDisablePaymentForm(false);
  }, [oOrder, formspays, formRef]);

  useEffect(() => {
    formRef.setFieldsValue({
      cliente: oClient.id,
      email: oClient.email,
    });
  }, [oClient]);

  useEffect(() => {
    const paymentMethodId = methods?.data?.[0]?.id;
    const paymentMethod = methods?.data?.[0];
    if (paymentMethod && paymentMethodId) {
      formRef.setFieldsValue({
        payment_method: `${paymentMethod.code}&${paymentMethod.id}`,
      });
    }
  }, [methods, formRef]);

  const handleValuesChange = (changedValues, allValues) => {
    onValuesChange(allValues);
  };

  const handleSearchForms = s => {
    if (s.length > 2) {
      let sQueries = generateQueries({ description: s, status: 1 }, formSearch);
      fQuery(sQueries, 0, 50);
    } else {
      fQuery();
    }
  };

  return (
    <Form
      form={formRef}
      layout="vertical"
      name="InvoiceForm"
      onFinish={onSubmit}
      onValuesChange={handleValuesChange}
      initialValues={{
        total: oOrder?.total_neto,
      }}
    >
      <Row gutter={[12, 12]}>
        <Col span={24}>
          <Form.Item label="Cliente" shouldUpdate>
            <span>{oClient.invoice_name}</span>
          </Form.Item>
          <Form.Item name="cliente" noStyle>
            <Input type="hidden" />
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item
            label="Correo Electronico"
            name="email"
            rules={[{ required: true, message: 'Campo requerido' }]}
          >
            <Input type="text" />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            label="Monto a facturar"
            name="total"
            rules={[
              { required: true, message: 'Campo requerido' },
              {
                validator: (_, value) => {
                  if (value <= 0) {
                    return Promise.reject(
                      'El total de la factura no puede ser menos de 0'
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <InputNumber
              style={{ width: '100%' }}
              min={0.01}
              max={oOrder.total_neto}
              precision={2}
            />
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item
            label="Forma de Pago"
            name="payment_form"
            rules={[{ required: true, message: 'Campo requerido' }]}
          >
            <SearchSelector
              allowClear
              handleSearch={debounce(handleSearchForms, 200)}
              loading={pLoading}
              onChange={() => fQuery()}
              placeholder="Seleccionar Forma de pago"
              disabled={disablePaymentForm}
            >
              {formspays?.data.map(oForm => (
                <Select.Option
                  key={oForm.id}
                  value={`${oForm.code}&${oForm.id}`}
                >
                  {oForm.code}-{oForm.description}
                </Select.Option>
              ))}
            </SearchSelector>
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item label="Método de Pago" shouldUpdate>
            {() => {
              const method = methods?.data?.[0];
              return mLoading ? (
                <span>Cargando...</span>
              ) : (
                <span>
                  {method?.code} - {method?.description}
                </span>
              );
            }}
          </Form.Item>
          <Form.Item name="payment_method" noStyle>
            <Input type="hidden" />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

TicketForm.propTypes = {
  formRef: PropTypes.object,
  onSubmit: PropTypes.func,
  oOrder: PropTypes.object,
  onValuesChange: PropTypes.func,
  oClient: PropTypes.object,
};
